import React from 'react';
import { LinkIcon, UnlinkIcon } from '@pushpay/iconography';
import { Inline } from '@pushpay/layout';
import { createUseStyles } from '@pushpay/styles';
import { Theme } from '@pushpay/theming/theme/giving';
import Tooltip from '@pushpay/tooltip';
import { ComponentProps } from '@pushpay/types';

const useStyles = createUseStyles((theme: Theme) => ({
	icon: {
		color: theme.colors['color-text-default']
	},
}));

export const LinkAndSync = ({
	displayName,
	'data-pp-at-target': targetId,
	linkAndSyncEnabled,
}: ComponentProps < { displayName: string, linkAndSyncEnabled: boolean }, undefined>) => {
	const classes = useStyles(undefined, undefined);

	const icon = linkAndSyncEnabled
		? <LinkIcon className={classes.icon} data-pp-at-target={`${targetId}-icon`} />
		: <UnlinkIcon className={classes.icon} data-pp-at-target={`${targetId}-icon`} />
	const pendoTarget = linkAndSyncEnabled
		? { "data-pendo-link-and-sync-enabled": true }
		: { "data-pendo-link-and-sync-enabled": false };
	const content = linkAndSyncEnabled
		? "Link & Sync enabled"
		: "Link & Sync disabled";

	return (
		<Inline>
			{displayName}
			<Tooltip
				content={content}
				placement="top"
				{...pendoTarget}
				data-pp-at-target={`${targetId}-tooltip`}
			>
				{icon}
			</Tooltip>
		</Inline>
	);
};
